<template>
  <QScrollArea
    v-if="games.length > 0"
    class="h-80"
    :visible="$q.screen.lt.md"
  >
    <div class="rounded flex gap-5">
      <div
        v-for="game in games"
        class="w-full"
      >
        <RouterLink
          :to="{name: 'lives', params: {sport: game.sport_id}}"
          class="w-full"
        >
          <div class="pl-4">
            <div class="rounded-lg hover:(border border-secondary) bg-dark-3 relative h-23 pl-18 pr-4">
              <div
                class="rounded-full h-20 w-20 grid items-center justify-center shadow-md shadow-secondary/30 bg-gradient-to-t from-secondary to-accent absolute -left-4 top-2"
              >
                <SportIcon
                  :sport-id="game.sport_id"
                  size="30px"
                />
              </div>
              <div class="w-full divide-y-2 divide-dark-1">
                <div class="grid grid-cols-5 py-2 px-2">
                  <div class="col-span-2 flex flex-nowrap justify-end gap-2">
                    <ImgIcon
                      :src="getLeagueIcon(game)"
                      size="18px"
                    />
                    <div class="gird truncate">
                      {{ game.league.name_ko }}
                    </div>
                  </div>
                  <div class="col-span-1 flex justify-center">
                    |
                  </div>
                  <div class="col-span-2 flex justify-start">
                    {{ dayjs(game.start_time).format('MM:DD HH:mm') }}
                  </div>
                </div>
                <div class="py-5 px-2 grid grid-cols-8">
                  <div class="col-span-3 grid items-center gap-5 grid-cols-4">
                    <ImgIcon
                      class="col-span-1"
                      :src="getIcon(game.home_team)"
                      size="20px"
                    />
                    <div class="col-span-3 text-left truncate">
                      {{ game.home_team.name_ko }}
                    </div>
                  </div>
                  <div class="col-span-2 text-xl font-bold flex justify-center text-[#27C8E5] whitespace-nowrap">
                    {{ getScore(game) }}
                  </div>
                  <div class="col-span-3 grid items-center gap-5 grid-cols-4">
                    <div class="col-span-3 text-right truncate">
                      {{ game.away_team.name_ko }}
                    </div>
                    <ImgIcon
                      class="col-span-1"
                      :src="getIcon(game.away_team)"
                      size="20px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </RouterLink>
      </div>
    </div>
  </QScrollArea>
  <div
    v-else
    class="md:h-80 bg-dark-3 rounded p-5"
  >
    <QImg
      :src="Bg"
      class="w-full h-full"
    />
  </div>
</template>
<script setup>
import Bg from '@/assets/home/hot/bg.png'
import ImgIcon from '@/components/Icons/ImgIcon.vue'
import SportIcon from '@/components/Icons/SportIcon.vue'
import { useTeam } from '@/composables/useTeam.js'
import { useLiveStore } from '@/stores/live.js'
import { useLeague } from '@/composables/useLeague.js'
import { useScore } from "@/composables/useScore.js"
import { dayjs } from '@/utils/index.js'
import { computed } from 'vue'

const { getIcon } = useTeam()

const liveStore = useLiveStore()
liveStore.fetchHot()

const games = computed(() => liveStore.hotGames.map(o => ({
  sport_id: o.sport_id,
  start_time: o.start_time,
  home_team: o.home_team,
  away_team: o.away_team,
  score: o.score,
  league: o.league,
  country: o.country,
})))

function getScore(game) {
  const { score } = useScore(game)

  return score.value ? `${ score.value[0] } : ${ score.value[1] }` : '-'
}

function getLeagueIcon(game) {
  game.league.country = game.country

  const { icon: leagueIcon } = useLeague(game.league)
  return leagueIcon.value
}
</script>
